import {lazy} from "react";

const PersonalizedAI = lazy(() => import("./PersonalizedAI"));

const personalizedAIRoutes = [
    {
        path: "/magic-chat/:id",
        element: <PersonalizedAI/>,
    },
];

export default personalizedAIRoutes;